import Vue from 'vue'
import App from './App.vue'
import VueHorizontal from 'vue-horizontal'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vueCustomElement from 'vue-custom-element'

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(VueHorizontal);
Vue.use(vueCustomElement);
Vue.component(VueHorizontal)
Vue.customElement('cu-content-box', App)
